import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	notificationProjectSettingsHeading: {
		defaultMessage: 'Customize project notifications',
		id: 'personal-settings-notifications-config-table.project-notifications-config.notification-project-settings-heading',
		description: 'Heading for project notifications section',
	},
	notificationProjectSettingsDescription: {
		defaultMessage:
			'Make your notifications specific to your project needs. Choose a project to set customized notifications.',
		id: 'personal-settings-notifications-config-table.project-notifications-config.notification-project-settings-description',
		description: 'Description for project notifications section',
	},
	notificationProjectSettingsAddProjectNotificationsButtonText: {
		defaultMessage: 'Add project notifications',
		id: 'personal-settings-notifications-config-table.project-notifications-config.notification-project-settings-add-project-notifications-button-text',
		description: 'Button text for Adding project notifications',
	},
	notificationProjectSettingsHardLimitWarningBannerText: {
		defaultMessage:
			'You can’t add more than 50 projects. In order to customize a new project, you’ll need to remove an existing one.',
		id: 'personal-settings-notifications-config-table.project-notifications-config.notification-project-settings-hard-limit-warning-banner-text',
		description:
			'Text for warning banner which is shown when 50 projects are configured for project notifications',
	},
	notificationProjectSettingsHardLimitWarningPopUpTextTitle: {
		defaultMessage: 'Maximum 50 projects.',
		id: 'personal-settings-notifications-config-table.project-notifications-config.notification-project-settings-hard-limit-warning-pop-up-text-title',
		description:
			'Title of the pop up text which shows up on hovering on the warning icon which is shown when 45 projects are configured for project notifications',
	},
	notificationProjectSettingsHardLimitWarningPopUpText: {
		defaultMessage:
			'You’re approaching the maximum number of projects you can create custom notifications for.',
		id: 'personal-settings-notifications-config-table.project-notifications-config.notification-project-settings-hard-limit-warning-pop-up-text',
		description:
			'Text for the pop up which shows up on hovering on the warning icon which is shown when 45 projects are configured for project notifications',
	},
});
